import React, { useState } from 'react'
import './login.css'
import { useNavigate } from 'react-router-dom';
import { login, setMe } from '../../api.service/user.service';

interface LoginCredentials {
    username: string
    password: string
}

const Login = () => {
    const navigate = useNavigate()


    const [credentials, setCredentials] = useState<LoginCredentials>({
        username: '',
        password: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setCredentials({
            ...credentials,
            [name]: value,
        });
    }




    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        login({role:credentials.username, appid: process.env.REACT_APP_APP_ID}).then(resp => {
            if(resp.status){
                const isAdmin = credentials?.username?.toLowerCase()?.includes('admin');
                setMe({ username: credentials?.username, isAdmin, token: resp.data.token })
                if (isAdmin) {
                    navigate('/admin');
                } else {
                    navigate('/home');
                }
            }
        })
        
    }



    return (
        <div className='wrapper'>
            <div className="container">
                <div className="card">
                    <h2>Login</h2>
                    <form onSubmit={onSubmit}>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Username"
                            value={credentials.username}
                            onChange={handleChange}
                            required />
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Password"
                            value={credentials.password}
                            onChange={handleChange}
                            required />
                        <button type="submit">Login</button>
                    </form>
                </div>
            </div>
        </div>


    )
}

export default Login